<template>
  <div id="NewsInformation">
    <div>
      <!-- <Navimg :path="require('@/assets/hhdimg/nav6.jpg')"></Navimg> -->
      <div id="swiper" class="container-fuild">
        <div class="swiper-container banner-swiper">
          <div class="swiper-wrapper">
            <div class="swiper-slide" v-for="(item, index) in swiperList" :key="index">
              <img class="swiper-lazy" :src="item" :alt="$t('home.banner')" />
            </div>
          </div>
          <div class="swiper-pagination"></div>
          <div class="swiper-button-prev"></div>
          <div class="swiper-button-next"></div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row gutter-0 wap-gutter-10">
        <div id="right" class="col-md-12 col-xs-12 ">
          <div class="top_box">
            <div class="inp_box">
              <div class="input_">
                <el-input :placeholder="$t('home.tip1')" v-model="searhValue">
                <div slot="suffix" class="search_box" @click="handleSearch">
                 <i  class="el-input__icon el-icon-search"></i>
                </div>
                </el-input>
              </div>
            
             <div :class="isTime?'date_box1':'date_box'">
             <!-- placeholder="选择日期" -->
             <!-- <i class="el-icon-date" :class="isTime?'blue':''"></i> -->
              <el-date-picker ref="datePicker"   @change="handleDateChange" v-model="dateTime"  :default-time="['00:00:00', '23:59:59']"
              type="datetimerange" :clearable="true"  :start-placeholder="$t('home.tip2')" :end-placeholder="$t('home.tip3')">
              </el-date-picker>
            </div>
          </div>
           
          </div>
          <PageHeader :title="name"></PageHeader>
          <div class="row gutter-0 d-flex wow bounceInLeft news-item" data-wow-delay="0.3s" v-for="(item,index) in newsList" :key="item.newsId">
            <!-- <div > -->
              <img :src="item.coverUrl" style="width:368px;height:250px;"></img>
            <!-- </div> -->
            <div class="col-md-4 col-xs-6 wow fadeInUp">
              <div class="news-time">{{item.newsTitle}}</div>
              <div class="news-content">
                {{item.description}}
              </div>
              <div class="news-num">
                <div class="news-num-left">{{item.createTime}}</div>
                <div class="news-num-rigth">{{$t('home.tip4')}}:{{item.viewNum}}</div>
              </div>
             <div class="news-more"  @click="onDetail(item)">
               <div class="news-more-btn">
                {{$t('home.gengduo')}}
               </div>
             </div>
            </div>
          </div>
          <div class="page" v-if="total>0">
            <el-pagination  background layout="prev, pager, next" :total="total" :page-size="6" @current-change="changeSize"></el-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {
    WOW
  } from 'wowjs';
  import Typeleft from "@/components/Typeleft.vue"
  import PageHeader from "@/components/PageHeader.vue"
  import {newList} from '@/api/modules/new'
  import Swiper from "swiper";
  import { homePage } from "@/api/modules/home";
  import { parseTime } from "@/utils/index";
  export default {
    name: 'NewsInformation',
    metaInfo() {
    return {
      title: this.PageTitle,
      meta: [
        {
          name: this.PagekeyWords,
          content: this.PageDescription,
        },
      ],
    };
  },
    components: {
      Typeleft,
      PageHeader
    },
    data() {
      return {
        total:0,
        pageNum:1,
        newsList: [],
        swiperList: [],
        name:this.$t('home.news'),
        PageTitle: "",
        PagekeyWords: "",
        PageDescription: "",
        swperInstance:null,
        searhValue:'',
        isTime:false,
        dateTime:[]
      }
    },
    watch: {
    swiperList: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          // 确保DOM更新完成后，重新初始化Swiper
          if (this.swperInstance) {
            this.swperInstance.destroy();
          }
          /* banner-swiper */
          this.swperInstance=new Swiper(".banner-swiper", {
            loop: true, // 循环模式选项
            effect: "fade",
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要分页器
            pagination: {
              el: ".swiper-pagination",
              clickable: true,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            // 延迟加载
            lazy: {
              loadPrevNext: true,
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* customer-swiper */
          new Swiper(".customer-swiper", {
            loop: true, // 循环模式选项
            slidesPerView: 3,
            //自动播放
            autoplay: {
              delay: 3000,
              stopOnLastSlide: false,
              disableOnInteraction: false,
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: true, //修改swiper的父元素时，自动初始化swiper
          });
          /* wowjs动画 */
          var wow = new WOW({
            boxClass: "wow",
            animateClass: "animated",
            offset: 0,
            mobile: true,
            live: true,
          });
          wow.init();
        });
      },
    },
  },
    mounted() {
      var wow = new WOW();
      wow.init();
      this.getBannerList()
      this.getList()
    },
    methods:{
    // 选择日期
    handleDateChange(value) {
      console.log('Selected Date Range:', value,this.dateTime);
      this.pageNum=1
      this.total=0
      this.getList()
    },

    getBannerList() {
      let data = {
        page: 1,
        moduleType:4,
        language: this.$store.getters.lang,
      };
      
      homePage(data).then((res) => {
        if (res.returnCode == 200&&res.data.length>0) {
           this.swiperList=res.data[0].bannerUrl.split(';')
           this.PageTitle = res.data[0].seoTitle;
           this.PagekeyWords = res.data[0].seoKeyWord;
           this.PageDescription = res.data[0].seoContent;
        }
      });
    },
      // 跳转详情
      onDetail(item){
        this.$router.push({
            path: '/newInfo',
            query: {
               data:encodeURIComponent(JSON.stringify(item))
            }
        })
      },
      // 改变页数
      changeSize(e){
        this.pageNum=e
        this.getList()
      },
      
      // 搜索
      handleSearch(){
        this.pageNum=1
        this.total=0
        this.getList()
      },

      // 获取新闻列表
      getList(){
        let data={
          pageSize:6,
          pageNum:this.pageNum,
          language:this.$store.getters.lang
        }
        if(this.dateTime.length>0){
          data['publishStartTime']=parseTime(this.dateTime[0])
          data['publishEndTime']=parseTime(this.dateTime[1])
        }
        if(this.searhValue){
          data['newsTitle']=this.searhValue
        }
        newList(data).then(res=>{
          if(res.returnCode){
            this.total=res.pageInfo.totalCount
            this.newsList=res.data
          }
        })
      }
    }
  }
</script>
<style scoped>
  .top_box{
    width:100%;
    height:200px;
    display:flex;
    align-items:center;
    justify-content:center;
    /* border:1px solid blue; */
  }

  .inp_box{
    width:100%;
    height:80px;
    /* border:1px solid #bbc0cf; */
    /* border-radius: 40px; */
    display:flex;
    align-items:center;
    justify-content:center;
    flex-wrap:wrap;
  }

  /deep/ .el-input__inner{
    /* width:80%; */
    height:60px;
    border-radius: 30px;
    /* border:none; */
    font-size:20px;
    background-color:#f7f7f7;
  }

  .input_{
     width:50%;
     display:flex;
     flex-grow:1;
     margin-bottom:10px;
     margin-right:10px;
  }

  /deep/ .el-input{
    
    /* height:60px;
    border:1px solid #bbc0cf;
    border-radius: 30px; */
    display:flex;
    align-items:center;
    flex-grow:1;
    
  }

  /deep/ .search_box{
    width:124px;
    height:60px;
    border-radius:30px;
    background-color:#169bd5;
    display:flex;
    justify-content:center;
    align-items:center;
   
  }

  /deep/ .el-input__suffix{
    right:0px;

    
  }

  /* /deep/ ._date .el-input__icon {
  
  display: none;
} */

  .search{
    width:80%;
  }

  /deep/ .inp_box .el-input__icon{
      color:#fff;
      font-size:38px;
      display:flex;
      justify-content:center;
      align-items:center;
  }

  /deep/ .date_box .el-input__icon{
    color:#606266 !important;
    font-size:30px;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-right:10px;
  }

  /deep/ .date_box1 .el-input__icon{
    color:#169bd5 !important;
    font-size:30px;
    display:flex;
    justify-content:center;
    align-items:center;
    margin-right:10px;
  }

  .date_box{
    height:60px;
    /* width:60px; */
    /* margin-left:15px; */
    display:flex;
    justify-content:center;
    align-items:center;
    color:#169bd5;
    margin-bottom:10px;
  }

  .date_box1{
    height:60px;
    /* width:60px; */
    /* margin-left:15px; */
    display:flex;
    justify-content:center;
    align-items:center;
    color:#169bd5;
    margin-bottom:10px;
  }

  /deep/ .date_box .el-input__inner{
    width:100%;
    /* border:none; */
    background-color:#f7f7f7;
    font-size:20px;
    display:flex;
    justify-content:center;
    background-color:#f7f7f7;
  }

  /deep/ .date_box1 .el-input__inner{
    /* border:none; */
    width:100%;
    background-color:#f7f7f7;
    display:flex;
    justify-content:center;
    background-color:#f7f7f7;
  }
  
  /deep/ .el-date-editor .el-range-input{
    font-size:20px;
    background-color:#f7f7f7;
  }

  /deep/ .el-date-editor .el-range-separator{
    display:flex;
    align-items:center;
  }

  .el-icon-date{
    font-size:43px;
  }

  .blue{
    color:#169bd5;
  }





 
  /* 整体盒子 */
  #NewsInformation {
    width: 100%;
    background-color: #f7f7f7;
  }

  #left {
    margin: 20px 0;
  }

  #right {
    padding: 20px 0;
  }

  .page{
    width: 100%;
    display:flex;
    justify-content:center;
    margin-top:15px;
  }

  #swiper .banner-swiper {
  width: 100%;
  height: 100%;
}

#swiper .banner-swiper .swiper-slide img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

#swiper .banner-swiper .swiper-slide {
  position: relative;
}

#swiper .banner-swiper .swiper-slide-title {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999999999;
  width: 100%;
  height: 100%;
  color: #fff;
  background: rgba(51, 51, 51, 0.534);
  text-align: center;
  line-height: 80px;
}

#swiper .banner-swiper .swiper-slide-title > h1 {
  font-size: 50px;
  margin-top: 12%;
}

#swiper .banner-swiper .swiper-slide-title > p {
  font-size: 20px;
  margin-top: 1%;
  font-weight: 700;
}

@media screen and (max-width: 768px) {
  #right {
    padding: 15px;
  }

  #swiper {
    height: 200px;
  }
}

  .news-item {
    background-color: #fff;
    margin-top: 20px;
    padding: 15px;
    border-radius: 10px;
    box-shadow: 0 8px 20px -10px rgba(0, 0, 0, 0.5);
    cursor:pointer;
  }

  .news-item img {
    margin-right: 15px;
    max-height: 250px;
  }

  .news-time {
    font-size: 28px;
    font-weight: 600;
  }

  .news-content {
    width: 100%;
    font-size: 20px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    margin-top: 10px;
  }

  .news-num {
    display: flex;
    margin-top: 10px;
  }

  .news-num-left {}

  .news-num-rigth {
    margin-left: 20px;

  }

  .news-more {
    
  }

  .news-more-btn{
    text-align: center;
    width: 150px;
    padding: 8px;
    border: 1px solid #ccc;
    border-radius: 20px;
    margin-top: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .news-more-btn:hover{
    background-color: #0c74b5;
        border: 1px solid #0c74b5;
    color: #fff;
  }
  .news-more-btn::after {
      position: relative;
      content: "\f105";
      font-family: "Font Awesome 5 Free";
      font-weight: 900;
      margin-left:5px;
      margin-top: 2px;
  }

  
  /deep/ .el-pagination{
    display: flex;
    
  }

  /deep/ .el-pager{
    display:flex
  }

  /deep/ .el-pagination.is-background .el-pager li{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    /* margin:0 !important; */
    font-size:18px;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-prev{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-next{
    width: 40px;
    height: 40px;
    border-radius: 50% !important;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 3px 1px -2px rgba(0, 0, 0, .2), 0 2px 2px 0 rgba(0, 0, 0, .14), 0 1px 5px 0 rgba(0, 0, 0, .12);
  }

  /deep/ .el-pagination .btn-next .el-icon{
    font-size:18px !important;
  }

  /deep/  .el-pagination .btn-prev .el-icon{
    font-size:18px !important;
  }
</style>



// WEBPACK FOOTER //
// src/view/NewsInformation.vue